import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UserSearchType } from 'src/app/core/enums/user-search-type.enum';
import { RightPanelService } from 'src/app/core/services/right-panel.service';
import { RightPanelType } from 'src/app/core/enums/right-panel-type.enum';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SelectUsersToAssignModalComponent } from '../../../../shared/modal-windows/select-user-to-assign-modal/select-user-to-assign-modal.component';
import { TicketService } from 'src/app/core/services/ticket/ticket.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { ComponentMessengerService } from 'src/app/core/services/component-messenger.service';
import { NotificationsService } from 'angular2-notifications';
import { UserAvatarComponent } from '../../../../../sb-modules/Frontend-User-Avatar-Module/user-avatar.component';
import { InlineSVGComponent } from '../../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { LoaderComponent } from '../../../../../sb-tools/typescript/components/loader/loader.component';

@Component({
    selector: 'app-access',
    templateUrl: './access.component.html',
    styleUrls: ['./access.component.scss'],
    imports: [UserAvatarComponent, InlineSVGComponent, LoaderComponent],
})
export class AccessComponent implements OnInit, OnDestroy {
    @Input() isLoaded: boolean;
    @Input() nonUsersText: string;
    @Input() ticketId;
    @Input() usersWithAccess;
    @Input() userType: UserSearchType;

    rightPanelTypeEnum = RightPanelType;

    private modalTitle;
    private modalUserPlaceholder;
    private unsubscriber = new Subject<void>();

    constructor(
        public rightPanelService: RightPanelService,
        private bsModalService: BsModalService,
        private ticketService: TicketService,
        private translateService: TranslateService,
        private notificationsService: NotificationsService,
        private componentMessengerService: ComponentMessengerService,
    ) {}

    ngOnInit() {
        if (this.userType === UserSearchType.team) {
            this.modalTitle = this.translateService.instant('Give access to this ticket to Socialboards users');
            this.modalUserPlaceholder = this.translateService.instant('Select users');
        } else {
            this.modalTitle = this.translateService.instant(
                'Give access to this ticket to Socialboards users or external collaborators',
            );
            this.modalUserPlaceholder = this.translateService.instant('Select users/vendors');
        }
    }

    openGiveAccessModal() {
        const initialState = {
            title: this.modalTitle,
            userPlaceholder: this.modalUserPlaceholder,
            userSearchType: this.userType,
            confirmText: this.translateService.instant('Give access'),
            confirmCallback: (data) => {
                return this.giveAccess(data);
            },
            comment: this.translateService.instant('Hi, can you please help me answer this customer?'),
        };

        this.bsModalService.show(SelectUsersToAssignModalComponent, {
            initialState,
            ignoreBackdropClick: true,
        });
    }

    giveAccess(data) {
        const processedData = {
            message: data.message,
            users: data.users.map((u) => u.id),
        };

        this.ticketService
            .giveAccess(this.ticketId, processedData)
            .pipe(takeUntil(this.unsubscriber))
            .subscribe(() => {
                data.users.forEach((user) => {
                    user.isSelected = false;
                });

                Array.prototype.push.apply(
                    this.usersWithAccess,
                    data.users.filter((newUser) => {
                        return !this.usersWithAccess.find((existedUser) => {
                            return newUser.email === existedUser.email;
                        });
                    }),
                );

                this.notificationsService.success(
                    this.translateService.instant('Success!'),
                    this.translateService.instant('Good') +
                        ', ' +
                        data.users
                            .map((user) => {
                                return (user.name || user.email).replace(/(<([^>]+)>)/gi, '');
                            })
                            .join(', ') +
                        ' ' +
                        this.translateService.instant('received an invite to access this ticket.'),
                );

                if (this.userType === UserSearchType.team) {
                    this.componentMessengerService.teamMembersWereUpdated(this.usersWithAccess);
                }
            });
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
